"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeListClientsState = exports.changeUpdateClientState = exports.changeCreateClientState = exports.clearAllClientForms = exports.clearUpdateClientParams = exports.clearCreateClientParams = exports.changeUpdateClientParams = exports.changeCreateClientParams = exports.changeClientListConfig = exports.CHANGE_CLIENT_LIST_CONFIG = exports.changeLoadedClientTempId = exports.CHANGE_LOADED_CLIENT_TEMP_ID = exports.loadClientToUpdate = exports.LOAD_CLIENT_TO_UPDATE = exports.changeClientState = exports.CHANGE_CLIENT_STATE = exports.clearClientParams = exports.CLEAR_CLIENT_PARAMS = exports.changeClientParams = exports.CHANGE_CLIENT_PARAMS = exports.setClients = exports.SET_CLIENTS = void 0;

var _reduxBatchedActions = require("redux-batched-actions");

var _createAction = require("skybase-ui/skybase-core/base/create-action");

var _getActionName = require("skybase-ui/skybase-core/utils/get-action-name");

var _constants = require("./constants");

var _constants2 = require("../constants");

var CREATE_CLIENT = _constants.CLIENTS_STATE_KEYS.CREATE_CLIENT,
    UPDATE_CLIENT = _constants.CLIENTS_STATE_KEYS.UPDATE_CLIENT,
    LIST = _constants.CLIENTS_STATE_KEYS.LIST;
var SET_CLIENTS = (0, _getActionName.getActionName)('SET_CLIENTS', _constants2.MODULE_NAME);
exports.SET_CLIENTS = SET_CLIENTS;

var setClients = function setClients(clients) {
  return (0, _createAction.createAction)(SET_CLIENTS, {
    clients: clients
  });
};

exports.setClients = setClients;
var CHANGE_CLIENT_PARAMS = (0, _getActionName.getActionName)('CHANGE_CLIENT_PARAMS', _constants2.MODULE_NAME);
exports.CHANGE_CLIENT_PARAMS = CHANGE_CLIENT_PARAMS;

var changeClientParams = function changeClientParams(key, attribute, value) {
  return (0, _createAction.createAction)(CHANGE_CLIENT_PARAMS, {
    key: key,
    attribute: attribute,
    value: value
  });
};

exports.changeClientParams = changeClientParams;
var CLEAR_CLIENT_PARAMS = (0, _getActionName.getActionName)('CLEAR_CLIENT_PARAMS', _constants2.MODULE_NAME);
exports.CLEAR_CLIENT_PARAMS = CLEAR_CLIENT_PARAMS;

var clearClientParams = function clearClientParams(key) {
  return (0, _createAction.createAction)(CLEAR_CLIENT_PARAMS, {
    key: key
  });
};

exports.clearClientParams = clearClientParams;
var CHANGE_CLIENT_STATE = (0, _getActionName.getActionName)('CHANGE_CLIENT_STATE', _constants2.MODULE_NAME);
exports.CHANGE_CLIENT_STATE = CHANGE_CLIENT_STATE;

var changeClientState = function changeClientState(key, state) {
  return (0, _createAction.createAction)(CHANGE_CLIENT_STATE, {
    key: key,
    state: state
  });
};

exports.changeClientState = changeClientState;
var LOAD_CLIENT_TO_UPDATE = (0, _getActionName.getActionName)('LOAD_CLIENT_TO_UPDATE', _constants2.MODULE_NAME);
exports.LOAD_CLIENT_TO_UPDATE = LOAD_CLIENT_TO_UPDATE;

var loadClientToUpdate = function loadClientToUpdate(client) {
  return (0, _createAction.createAction)(LOAD_CLIENT_TO_UPDATE, {
    client: client
  });
};

exports.loadClientToUpdate = loadClientToUpdate;
var CHANGE_LOADED_CLIENT_TEMP_ID = (0, _getActionName.getActionName)('CHANGE_LOADED_CLIENT_TEMP_ID', _constants2.MODULE_NAME);
exports.CHANGE_LOADED_CLIENT_TEMP_ID = CHANGE_LOADED_CLIENT_TEMP_ID;

var changeLoadedClientTempId = function changeLoadedClientTempId(id) {
  return (0, _createAction.createAction)(CHANGE_LOADED_CLIENT_TEMP_ID, {
    id: id
  });
};

exports.changeLoadedClientTempId = changeLoadedClientTempId;
var CHANGE_CLIENT_LIST_CONFIG = (0, _getActionName.getActionName)('CHANGE_CLIENT_LIST_CONFIG', _constants2.MODULE_NAME);
exports.CHANGE_CLIENT_LIST_CONFIG = CHANGE_CLIENT_LIST_CONFIG;

var changeClientListConfig = function changeClientListConfig(config) {
  return (0, _createAction.createAction)(CHANGE_CLIENT_LIST_CONFIG, {
    config: config
  });
}; // Factory actions


exports.changeClientListConfig = changeClientListConfig;

var changeCreateClientParams = function changeCreateClientParams(attribute, value) {
  return changeClientParams(CREATE_CLIENT, attribute, value);
};

exports.changeCreateClientParams = changeCreateClientParams;

var changeUpdateClientParams = function changeUpdateClientParams(attribute, value) {
  return changeClientParams(UPDATE_CLIENT, attribute, value);
};

exports.changeUpdateClientParams = changeUpdateClientParams;

var clearCreateClientParams = function clearCreateClientParams() {
  return clearClientParams(CREATE_CLIENT);
};

exports.clearCreateClientParams = clearCreateClientParams;

var clearUpdateClientParams = function clearUpdateClientParams() {
  return clearClientParams(UPDATE_CLIENT);
};

exports.clearUpdateClientParams = clearUpdateClientParams;

var clearAllClientForms = function clearAllClientForms() {
  return function (dispatch) {
    dispatch((0, _reduxBatchedActions.batchActions)([clearCreateClientParams(), clearUpdateClientParams()]));
  };
};

exports.clearAllClientForms = clearAllClientForms;

var changeCreateClientState = function changeCreateClientState(state) {
  return changeClientState(CREATE_CLIENT, state);
};

exports.changeCreateClientState = changeCreateClientState;

var changeUpdateClientState = function changeUpdateClientState(state) {
  return changeClientState(UPDATE_CLIENT, state);
};

exports.changeUpdateClientState = changeUpdateClientState;

var changeListClientsState = function changeListClientsState(state) {
  return changeClientState(LIST, state);
};

exports.changeListClientsState = changeListClientsState;
//# sourceMappingURL=actions.js.map